export default __webpack_public_path__ + "static/media/inspector-symbol-17.37555ac4.svg";